<template>
    <div>
        <rkm-area
            no-margin-top
            title="Filtros"
            type="fieldset"
        >
            <rkm-form
                v-if="model"
                ref="RkmForm"
            >
                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-date-picker
                            :end-validations="validations.periodo.date.end"
                            :max-date="maxDate"
                            :min-date="minDate"
                            :range-inline="false"
                            :start-validations="validations.periodo.date.start"
                            end-label="Até"
                            range
                            start-label="Período de"
                            v-model="model.periodo.date"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-time-picker
                            :disabled="!isPeriodoFill"
                            label="Hora de"
                            v-model="model.periodo.time.start"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-time-picker
                            :disabled="!isPeriodoFill"
                            label="Até"
                            v-model="model.periodo.time.end"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-select
                            :disabled="!isPeriodoFill"
                            :options="form.unidades"
                            @change="unidadeChange()"
                            default-option-text="Todas"
                            label="Unidade"
                            show-default-option
                            text-field="nomeFantasia"
                            v-model="model.unidadeId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            :disabled="!isPeriodoFill"
                            :options="form.locaisAtendimento"
                            @change="localAtendimentoChange()"
                            default-option-text="Todos"
                            label="Local de atendimento"
                            show-default-option
                            text-field="nome"
                            v-model="model.localAtendimentoId"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-select
                            :disabled="!isPeriodoFill"
                            :options="form.ocupacoes"
                            @change="ocupacaoChange()"
                            default-option-text="Todos"
                            label="CBO"
                            show-default-option
                            text-field="nome"
                            v-model="model.ocupacaoId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            :disabled="!isPeriodoFill"
                            :options="form.profissionais"
                            @change="profissionalChange()"
                            default-option-text="Todos"
                            label="Profissional"
                            show-default-option
                            text-field="nome"
                            v-model="model.profissionalId"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-multiselect
                            :disabled="!isPeriodoFill"
                            :mandatory="true"
                            :options="form.medicamentos"
                            @update:dropdownClosed="medicamentoChange()"
                            label="Medicamento(s)"
                            optionNameKey="nome"
                            optionTextSelecteds="medicamento selecionado"
                            v-model="model.medicamentoId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-input-autocomplete
                            :disabled="!isPeriodoFill"
                            :repository="repositories.relatorioPrescricaoInterna"
                            :request-query-string-params="getFilter()"
                            :search-fields="[
                                { key: 'cadastro_cidadao.nome', searchable: true }
                            ]"
                            label="Paciente"
                            v-model="model.paciente"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="3">
                        <rkm-form-input
                            :disabled="!isPeriodoFill || (model.paciente && model.paciente.prontuario != null)"
                            :validations="validations.prontuario"
                            label="Prontuário"
                            v-model="model.prontuario"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-input
                            label="FAA"
                            type="number"
                            v-model="model.faa"
                        />
                    </rkm-col>

                    <rkm-col cols="4">
                        <rkm-form-select
                            :disabled="!isPeriodoFill"
                            :options="form.status"
                            defaultOptionText="Todos"
                            label="Status"
                            show-default-option
                            text-field="nome"
                            v-model="model.status"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col class="flex-grow-0 text-nowrap">
                        <rkm-button
                            :disabled="!isPeriodoFill && !model.faa"
                            :label="false"
                            @click="handleBuscar()"
                            color="primary"
                        >
                            Buscar
                        </rkm-button>

                        <rkm-button
                            :disabled="!isPeriodoFill && !model.faa"
                            :label="false"
                            @click="limpar()"
                        >
                            Limpar
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
            </rkm-form>
        </rkm-area>

        <rkm-area
            no-margin-top
            title="Resultado"
        >
            <template v-slot:trailing>
                <rkm-dropdown
                    class="mr-2"
                    color="primary"
                    cols="1"
                    menu-class="auto-scroll"
                    no-caret
                    small
                    title="Colunas"
                    v-rkm-tooltip.hover
                >
                    <template v-slot:button-content>
                        <rkm-icon icon="columns" />
                    </template>

                    <rkm-form-checkbox
                        :indeterminate="indeterminate"
                        @change="handleSelectedColumns"
                        class="mx-2"
                    >
                        Todas
                    </rkm-form-checkbox>

                    <rkm-form-checkbox-group
                        :options="cols"
                        class="mx-2"
                        stacked
                        v-model="selectedCols"
                    />
                </rkm-dropdown>

                <rkm-button
                    :disabled="items.length === 0"
                    @click="imprimir()"
                    color="info"
                    small
                    title="Imprimir"
                >
                    <rkm-icon icon="print" />
                </rkm-button>
            </template>

            <rkm-table
                v-if="form"
                :fields="fields"
                :items="items"
                :sort-compare="sortCompare"
            >

                <template #afterTable v-if="items.length > 0">
                    <rkm-row>
                        <rkm-col
                            cols="12"
                            class="total"
                        >
                            Total: {{ totalAtendimentos }}
                        </rkm-col>
                    </rkm-row>
                </template>
            </rkm-table>
        </rkm-area>
    </div>
</template>

<script>
// Mixins.
import { repository, error, data, object, stringCase, debounce } from '@/mixins'

// Vuex.
import { mapActions } from 'vuex'

// Moment.
import moment from 'moment'

// Filters
import formatsFilter from '@/filters/formats'

export default {
    computed: {
        minDate() {

            const end = this.model.periodo.date.end
            const dataAtual = moment(this.additionals.dataAtual, 'DD/MM/YYYY')

            if (end != null) {

                return moment(end).subtract(31, 'days').format('DD/MM/YYYY')
            }

            if (this.model.periodo.date.start == null) {

                return null
            }

            return dataAtual.subtract(31, 'days').format('DD/MM/YYYY')
        },
        maxDate() {

            const start = this.model.periodo.date.start
            const dataAtual = moment(this.additionals.dataAtual, 'DD/MM/YYYY')

            if (start != null) {

                const end = moment(start).add(30, 'days')

                if (end.isBefore(dataAtual)) {

                    return end.format('DD/MM/YYYY')
                }
            }

            return dataAtual.format('DD/MM/YYYY')
        },
        fields() {
            let fields = [
                {
                    key: 'atendidoEm',
                    label: 'Data',
                    sortable: true,
                },
                {
                    key: 'medicamento',
                    label: 'Medicamento',
                    sortable: true
                },
                {
                    key: 'nomeMedicoPrescritor',
                    label: 'Médico prescritor',
                    sortable: true
                },
                {
                    key: 'nomeAplicador',
                    label: 'Aplicador',
                    sortable: true
                },
                {
                    key: 'nomePaciente',
                    label: 'Paciente',
                    sortable: true
                },
                {
                    key: 'numeroFaa',
                    label: 'FAA',
                    sortable: true
                },
                {
                    key: 'statusAplicacao',
                    label: 'Status',
                    sortable: true
                }
            ]

            this.selectedCols.map(column => {

                const col = this.cols.find(find => find.value === column)
                if (col.value !== 'todas') {

                    fields.push({ key: col.value, label: col.text, sortable: true  })
                }
            })

            return fields
        },
        cols() {

            return this.columns
        },
        validations() {

            return {
                periodo: {
                    date: {
                        start: { required: !this.model.faa },
                        end: { required: !this.model.faa },
                    },
                },
                prontuario: { max: 6 },
            }
        },
        isPeriodoFill() {

            return this.model && this.model.periodo.date.start != null && this.model.periodo.date.end != null
        },
        status() {

            return this.form && this.form.status ? this.sortStatus() : []
        }
    },
    created() {
        this.repositories = {
            relatorioPrescricaoInterna: this.getConectaSusRepository('prontoAtendimento.relatorioPrescricaoInterna'),
            impressao: this.getConectaSusRepository('impressao.prontoAtendimento'),
        }

        this.load()
    },
    data: () => ({
        items: [],
        totalAtendimentos: 0,
        model: null,
        form: null,
        additionals: null,
        indeterminate: false,
        filterDefault: {},
        columns: [
            {
                value: 'nomeUnidade',
                text: 'Unidade',
            },
            {
                value: 'localAtendimento',
                text: 'Local de atendimento',
            },
            {
                value: 'ocupacaoMedico',
                text: 'CBO Médico',
            },
            {
                value: 'ocupacaoAplicador',
                text: 'CBO Aplicador',
            },
            {
                value: 'prontuario',
                text: 'Prontuário',
            },
        ],
        selectedCols: [],
        debounceDelay: 400,
    }),
    methods: {
        ...formatsFilter,
        ...mapActions(['setLoading', 'unsetLoading']),
        sortCompare(a, b, key) {

            if (key === 'atendidoEm') {

                const dateA = moment(a[key], 'DD/MM/YYYY HH:mm')
                const dateB = moment(b[key], 'DD/MM/YYYY HH:mm')

                if (dateA > dateB) return 1
                else if (dateA < dateB) return -1
                else return 0

            } else {

                return false
            }
        },
        handleSelectedColumns(selected) {

            if (selected) {

                this.cols.map(col => {

                    this.selectedCols.push(col.value)
                })

            } else {

                this.selectedCols = []
            }
        },
        load() {
            this.setLoading()

            this.repositories.relatorioPrescricaoInterna.list()
                .then(({ data }) => {

                    this.model = this.clone(data.model)
                    this.form = this.clone(data.form)
                    this.additionals = this.clone(data.additionals)

                    this.filterDefault = {
                        form: this.clone(this.form),
                        model: this.clone(this.model)
                    }

                    this.addPeriodoWatch()
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        addPeriodoWatch() {

            this.$watch('model.periodo.date', {
                deep: true,
                handler() {

                    this.model.faa = null
                    this.model.localAtendimentoId = null
                    this.model.medicamentoId = null
                    this.model.ocupacaoId = null
                    this.model.paciente = null
                    this.model.periodo.time.end = null
                    this.model.periodo.time.start = null
                    this.model.profissionalId = null
                    this.model.status = null
                    this.model.unidadeId = null

                    this.form.locaisAtendimento = []
                    this.form.medicamentos = []
                    this.form.ocupacoes = []
                    this.form.profissionais = []
                    this.form.status = []
                    this.form.unidades = []

                    const filter = this.getFilter()

                    if (filter) {

                        this.setLoading()

                        this.repositories.relatorioPrescricaoInterna.list(filter)
                            .then(({ data }) => {

                                this.form = this.clone(data.form);
                            })
                            .catch(this.handleError)
                            .finally(() => this.unsetLoading())
                    }
                }
            })
        },
        peridoTimeChange() {

            this.model.localAtendimentoId = null
            this.model.medicamentoId = null
            this.model.ocupacaoId = null
            this.model.paciente = null
            this.model.profissionalId = null
            this.model.unidadeId = null

            this.form.locaisAtendimento = []
            this.form.medicamentos = []
            this.form.ocupacoes = []
            this.form.profissionais = []
            this.form.status = []
            this.form.unidades = []

            const filter = this.getFilter()

            if (filter) {

                this.setLoading()

                this.repositories.relatorioPrescricaoInterna.list(filter)
                    .then(({ data }) => {

                        this.form = this.clone(data.form);
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        unidadeChange() {

            this.model.localAtendimentoId = null
            this.model.medicamentoId = null
            this.model.ocupacaoId = null
            this.model.paciente = null
            this.model.profissionalId = null
            this.model.status = null

            this.form.locaisAtendimento = []
            this.form.medicamentos = []
            this.form.ocupacoes = []
            this.form.profissionais = []
            this.form.status = []

            const filter = this.getFilter()

            if (filter) {

                this.setLoading()

                this.repositories.relatorioPrescricaoInterna.filtragemPorUnidade(filter)
                    .then(({ data }) => {

                        this.form.locaisAtendimento = this.clone(data.locaisAtendimento)
                        this.form.medicamentos = this.clone(data.medicamentos)
                        this.form.ocupacoes = this.clone(data.ocupacoes)
                        this.form.profissionais = this.clone(data.profissionais)
                        this.form.status = this.clone(data.status)
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        localAtendimentoChange() {

            this.model.medicamentoId = null
            this.model.ocupacaoId = null
            this.model.paciente = null
            this.model.profissionalId = null
            this.model.status = null


            this.form.medicamentos = []
            this.form.ocupacoes = []
            this.form.profissionais = []
            this.form.status = []
            const filter = this.getFilter()

            if (filter) {

                this.setLoading()

                this.repositories.relatorioPrescricaoInterna.filtragemPorLocalAtendimento(filter)
                    .then(({ data }) => {

                        this.form.medicamentos = this.clone(data.medicamentos)
                        this.form.ocupacoes = this.clone(data.ocupacoes)
                        this.form.profissionais = this.clone(data.profissionais)
                        this.form.status = this.clone(data.status)
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        ocupacaoChange() {

            this.model.medicamentoId = null
            this.model.paciente = null
            this.model.profissionalId = null
            this.model.status = null

            this.form.medicamentos = []
            this.form.profissionais = []
            this.form.status = []

            const filter = this.getFilter()

            if (filter) {

                this.setLoading()

                this.repositories.relatorioPrescricaoInterna.filtragemPorOcupacao(filter)
                    .then(({ data }) => {

                        this.form.profissionais = this.clone(data.profissionais)
                        this.form.medicamentos = this.clone(data.medicamentos)
                        this.form.status = this.clone(data.status)
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        profissionalChange() {

            this.model.medicamentoId = null
            this.model.paciente = null
            this.model.status = null

            this.form.medicamentos = []
            this.form.status = []

            const filter = this.getFilter()

            if (filter) {

                this.setLoading()

                this.repositories.relatorioPrescricaoInterna.filtragemPorProfissional(filter)
                    .then(({ data }) => {

                        this.form.medicamentos = this.clone(data.medicamentos)
                        this.form.status = this.clone(data.status)
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        medicamentoChange() {

            this.model.paciente = null
            this.model.status = null

            this.form.status = []

            const filter = this.getFilter()

            if (filter) {

                this.setLoading()

                this.repositories.relatorioPrescricaoInterna.filtragemPorMedicamento(filter)
                    .then(({ data }) => {

                        this.form.status = this.clone(data.status)
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        handleBuscar() {

            this.$refs.RkmForm.validate()
                .then(valid => {

                    if (!valid) return

                    this.setLoading()

                    this.items = []

                    this.repositories.relatorioPrescricaoInterna.index(this.getFilter())
                        .then(({ data }) => {

                            this.items = data.atendimentos
                            this.totalAtendimentos = data.totalAtendimentos
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })
        },
        imprimir() {

            this.$refs.RkmForm.validate()
                .then(valid => {

                    if (!valid) return

                    this.setLoading()

                    const filter = this.getFilterPrint()

                    this.repositories.impressao.relatorioPrescricaoInterna(filter)
                        .then(response => {

                            this.download(response)
                        })
                        .finally(() => this.unsetLoading())
                })
        },
        getFilterPrint() {

            const filter = this.getFilter()

            const cols = JSON.parse(JSON.stringify(this.fields)).map((field) => {
                field.key = this.camelToSnake(field.key)
                return field
            })

            filter.columns = cols

            const unidade = this.form.unidades.find(f => f.id === this.model.unidadeId)
            filter.unidade = unidade ? unidade.nomeFantasia : 'Todas'

            const localAtendimento = this.form.locaisAtendimento.find(f => f.id === this.model.localAtendimentoId)
            filter.local_atendimento = localAtendimento ? localAtendimento.nome : 'Todos'

            const ocupacao = this.form.ocupacoes.find(f => f.id === this.model.ocupacaoId)
            filter.ocupacao = ocupacao ? ocupacao.nome : 'Todos'

            const profissional = this.form.profissionais.find(f => f.id === this.model.profissionalId)
            filter.profissional = profissional ? profissional.nome : 'Todos'

            if (this.model.medicamentoId.length === 1) {

                filter.medicamento = "1 medicamento selecionado";
            } else if (this.model.medicamentoId.length > 1 && this.model.medicamentoId.length < this.form.medicamentos.length) {

                filter.medicamento = `${this.model.medicamentoId.length} medicamentos selecionados`;
            } else {

                filter.medicamento = "Todos";
            }

            filter.paciente = this.model.paciente ? this.model.paciente.nome : 'Todos'

            filter.faa = this.model.faa ? this.model.faa : 'Todos'

            const status = this.form.status.find(f => f.valor === this.model.status)
            filter.status_descricao = status ? status.descricao : 'Todos'

            filter.prontuario_impressao = this.model.prontuario ? this.model.prontuario : 'Todos';

            return filter
        },
        getFilter() {

            if (this.isPeriodoFill || this.model.faa) {

                const filter = this.clone(this.model)
                filter.pacienteId = filter.paciente && filter.paciente.id
                filter.periodo.date.start = this.getFormatedDate(filter.periodo.date.start, 'DD/MM/YYYY')
                filter.periodo.date.end = this.getFormatedDate(filter.periodo.date.end, 'DD/MM/YYYY')

                return this.camelObjectKeysToSnakeRecursive(filter)
            }

            return null
        },
        download(response) {

            const content = new Blob([response.data], {type: response.headers['content-type']})
            const link = document.createElement('a')
            const url = URL.createObjectURL(content)

            link.href = url
            link.target = '_blank'
            link.click()
            link.remove()
        },
        limpar() {

            this.form = this.clone(this.filterDefault.form)
            this.model = this.clone(this.filterDefault.model)
            this.$refs.RkmForm.resetValidator()
        },
        sortStatus() {

            return this.form.status.sort((a,b) =>
                (a.descricao > b.descricao) ? 1 : ((b.descricao > a.descricao) ? -1 : 0));
        }
    },
    mixins: [ repository, error, data, object, stringCase, debounce ],
    watch: {
        'selectedCols': function (newValue) {

            this.indeterminate = false

            if (newValue.length > 0 && newValue.length != this.cols.length) {

                this.indeterminate = true
            }
        },
        'model.paciente' : function () {

            this.model.prontuario = this.model.paciente ? this.model.paciente.prontuario : null

            const filter = this.getFilter()


            if (filter) {

                this.setLoading()

                this.repositories.relatorioPrescricaoInterna.list(filter)
                    .then(({ data }) => {

                        this.form = this.clone(data.form);
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        'model.faa': function (newValue) {

            if (newValue) {

                this.model.periodo.date.start = null
                this.model.periodo.date.end = null
            }
        },
        'model.periodo.time.start': function (newValue) {
            if (newValue) {
                this.peridoTimeChange()
            }
        },
        'model.periodo.time.end': function (newValue) {
            if (newValue) {
                this.peridoTimeChange()
            }
        },
    }
}
</script>

<style scoped>
    .total {
        text-align: right;
        font-weight: bold;
    }

    .dropdown >>> .auto-scroll {
        max-height: 400px;
        overflow-y: auto;
        width: 400px;
    }

    .border-bottom {
        border-bottom: 1px solid rgb(27, 11, 11);
    }
</style>